/* heading-item.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgd8bj%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065UPgdg%7Bpadding-block%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
import { memo } from 'react';
import type { HeadingItemProps } from '../types';
const headingStyles = null;

/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
const HeadingItem: import('react').MemoExoticComponent<({
  children,
  testId,
  headingLevel,
  id,
  className: UNSAFE_className,
  ...rest
}: HeadingItemProps) => JSX.Element> = memo(({
  children,
  testId,
  headingLevel = 2,
  id,
  // Although this isn't defined on props it is available because we've used
  // Spread props below and on the jsx element. To forcibly block usage I've
  // picked it out and supressed the expected type error.
  // @ts-expect-error
  className: UNSAFE_className,
  ...rest
}: HeadingItemProps) => {
  return <div role="heading" aria-level={headingLevel} data-testid={testId} data-ds--menu--heading-item id={id}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax(["_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK", UNSAFE_className])} {...rest}>
				{children}
			</div>;
});
export default HeadingItem;